/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deep_Match_Gap_AnalysisInputs */

const en_deep_match_gap_analysis = /** @type {(inputs: Deep_Match_Gap_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gap Analysis`)
};

const de_deep_match_gap_analysis = /** @type {(inputs: Deep_Match_Gap_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gap Analysis`)
};

const fr_deep_match_gap_analysis = /** @type {(inputs: Deep_Match_Gap_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gap Analysis`)
};

const es_deep_match_gap_analysis = /** @type {(inputs: Deep_Match_Gap_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gap Analysis`)
};

const it_deep_match_gap_analysis = /** @type {(inputs: Deep_Match_Gap_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gap Analysis`)
};

const nl_deep_match_gap_analysis = /** @type {(inputs: Deep_Match_Gap_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gap Analysis`)
};

const pl_deep_match_gap_analysis = /** @type {(inputs: Deep_Match_Gap_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gap Analysis`)
};

const fi_deep_match_gap_analysis = /** @type {(inputs: Deep_Match_Gap_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gap Analysis`)
};

const da_deep_match_gap_analysis = /** @type {(inputs: Deep_Match_Gap_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gap Analysis`)
};

const sv_deep_match_gap_analysis = /** @type {(inputs: Deep_Match_Gap_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gap Analysis`)
};

/**
* | output |
* | --- |
* | "Gap Analysis" |
*
* @param {Deep_Match_Gap_AnalysisInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const deep_match_gap_analysis = /** @type {((inputs?: Deep_Match_Gap_AnalysisInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deep_Match_Gap_AnalysisInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_deep_match_gap_analysis(inputs)
	if (locale === "fr") return fr_deep_match_gap_analysis(inputs)
	if (locale === "es") return es_deep_match_gap_analysis(inputs)
	if (locale === "it") return it_deep_match_gap_analysis(inputs)
	if (locale === "nl") return nl_deep_match_gap_analysis(inputs)
	if (locale === "pl") return pl_deep_match_gap_analysis(inputs)
	if (locale === "fi") return fi_deep_match_gap_analysis(inputs)
	if (locale === "da") return da_deep_match_gap_analysis(inputs)
	if (locale === "sv") return sv_deep_match_gap_analysis(inputs)
	return en_deep_match_gap_analysis(inputs)
});